import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { getLocale, setLocale } from '@/paraglide/runtime.js';
import * as m from '@/paraglide/messages.js';

export function LanguageSelect() {
  const locale = getLocale();
  const choices = [
    { value: 'fr', label: m.language_french() },
    { value: 'en', label: m.language_english() },
  ];
  const label = choices.find((choice) => choice.value === locale)?.label;
  return (
    <Select
      value={locale}
      items={choices}
      onValueChange={(nextLocale) => {
        if (nextLocale === 'fr' || nextLocale === 'en') setLocale(nextLocale);
      }}
    >
      <SelectTrigger
        aria-label={m.language_label()}
        className="w-28 shrink-0 @max-[18rem]/shell-content:w-auto"
      >
        <SelectValue>
          <span className="@max-[18rem]/shell-content:hidden">{label}</span>
          <span className="hidden @max-[18rem]/shell-content:inline" aria-label={label}>
            {locale.toUpperCase()}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {choices.map((choice) => (
          <SelectItem key={choice.value} value={choice.value} lang={choice.value}>
            {choice.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
